/**
 * @func validateEmail
 * @param {string} value - The string to validate.
 * @return {boolean}
 * @desc Checks that the value is a valid email address.
 * ```js
 * validateEmail('example@gmail.com');
 * // returns true
 *
 * validateEmail('example.com');
 * // returns false
 *```
 * @memberof module:Validators
 * @instance
 */
function validateEmail(value) {
    /* eslint-disable no-useless-escape */
    return !!value.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
}

export { validateEmail as default };
